<script>
    export let letter;
    export let cssClass;
</script>

<style lang="scss">
    @import "variables";
    .egg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        // background-color: rgba($c-lightest,0.2);
        background-color: $c-accent;
        border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
        width: 45%;
        height: 60%;
        &.is-big, &.is-modal {
            width: 25%;
            height: 33%;
        }

        &.is-modal {
          background-color: $c-primary;
        }
        
      }
      
      .egg__letter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-transform: uppercase;
        font-size: inherit;
      }
</style>

<div class="egg {cssClass}"><span class="egg__letter">{letter}</span></div>